import { createUseStyles } from 'react-jss'

export default createUseStyles({
  container: {
    color: 'var(--chat-bubble__text__color)',
    display: 'flex',
    justifyContent: ({ isMe }) => isMe ? 'flex-end' : 'flex-start',
    letterSpacing: '-0.2 em',
    opacity: 0.8,
    fontFamily: 'BentonSansRegular'
  },
  text: {
    marginTop: '10px',
    fontSize: '12px',
    lineHeight: '16px'
  }
})
